import { Box, Button, Divider, Flex } from '@podiumhq/design-system';

import { TRIAL_CHECKOUT_ROUTE } from 'components/Checkout/constants';
import { BUY_NOW_CARDS } from 'components/PricingPackaging/constants';
import { getBundlePrices } from 'components/PricingPackaging/utils';
import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';

import { Subheading } from '../../styles';
import { redirectToOnboarding } from '../../utils';

import BuyNowCard from './BuyNowCard';

const BUTTON_CTA_LABEL = 'View all plan details';
const TITLE_MOBILE =
  'Already know what you want? Pick a plan today, and you’ll get 10% off.';
const TITLE_DESKTOP =
  'Want access to all that Podium has to offer? Pick a plan today, and get 10% off every month for as long as you continue to use Podium.';

const BuyNowWithDiscountContent = ({ isMobile }) => {
  const { changeCheckoutPage, discountPrices } = useSelectPlanCheckoutContext();
  const handleViewPlans = () => changeCheckoutPage(TRIAL_CHECKOUT_ROUTE);

  return (
    <>
      <Subheading paddingBottom="0">
        {isMobile ? TITLE_MOBILE : TITLE_DESKTOP}
      </Subheading>

      <Flex
        align={isMobile ? 'center' : 'flex-end'}
        direction={isMobile ? 'column' : 'row'}
        gap="8px"
        mb="21.5px"
        mt="24px"
      >
        {BUY_NOW_CARDS.map((card) => (
          <BuyNowCard
            key={card.cardId}
            {...card}
            {...getBundlePrices({
              allPrices: discountPrices,
              bundlePlan: card.bundlePlanName,
            })}
          />
        ))}
      </Flex>

      {!isMobile && (
        <>
          <Flex justifyContent="center">
            <Button
              color="blue.base"
              onClick={handleViewPlans}
              size="sm"
              variant="ghost"
            >
              {BUTTON_CTA_LABEL}
            </Button>
          </Flex>

          <Divider mb="24px" mt="19px" />
        </>
      )}

      <Box justifyContent="right">
        <Button
          color="silver.lightest"
          float={isMobile ? 'none' : 'right'}
          onClick={redirectToOnboarding}
          size="md"
          variant="primary"
          width={isMobile ? '100%' : 'auto'}
        >
          Continue with free trial
        </Button>
      </Box>

      {isMobile && (
        <Flex justifyContent="center">
          <Button
            color="blue.base"
            mt="15.5px"
            onClick={handleViewPlans}
            size="sm"
            variant="ghost"
          >
            {BUTTON_CTA_LABEL}
          </Button>
        </Flex>
      )}
    </>
  );
};

export default BuyNowWithDiscountContent;
